<template>
  <div class="no-data">
    <span class="icon"></span>
    <h2 v-if="heading">{{ heading }}</h2>
    <p>{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: 'noData',
  props: {
    heading: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: 'No Data Found'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/noData.vue